import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { MissingPlayer } from '@sorare/core/src/atoms/icons/MissingPlayer';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM, LabelL } from '@sorare/core/src/atoms/typography';

import { GridBackground } from '@sorare/gameplay/src/components/rivals/GridBackground';
import { BackgroundAligned } from '@sorare/gameplay/src/components/rivals/GridBackground/BackgroundAligned';
import { GridDivWithBorder } from '@sorare/gameplay/src/components/rivals/GridBackground/GridDivWithBorder';

const PastSeasonDiv = styled(GridDivWithBorder)`
  background: rgba(var(--c-rgb-rivals-reputation), 0.15);
  backdrop-filter: blur(30px);
`;
const CurrentSeasonDiv = styled(GridDivWithBorder)`
  background: rgba(var(--c-rgb-rivals-friendlies), 0.15);
  backdrop-filter: blur(30px);
`;
const StyledBackgroundAligned = styled(BackgroundAligned)`
  width: 100%;
  padding: 0 var(--double-unit);
`;

const PastSeasonMessage = () => {
  return (
    <Vertical gap={2} center>
      <PastSeasonDiv borderColor="var(--c-rivals-reputation)">
        <MissingPlayer
          width={24}
          height={24}
          color="var(--c-rivals-reputation)"
        />
      </PastSeasonDiv>
      <Vertical gap={0.5} className="text-center">
        <HeadlineM>
          <FormattedMessage
            id="IncompleteLeaderboard.incomplete"
            defaultMessage="Incomplete Leaderboard"
          />
        </HeadlineM>
        <LabelL color="var(--c-neutral-700)">
          <FormattedMessage
            id="IncompleteLeaderboard.noPromotion"
            defaultMessage="No promotion or relegation this week"
          />
        </LabelL>
      </Vertical>
    </Vertical>
  );
};

type CurrentSeasonMessageProps = {
  rankingsCount: number;
  maximumSize: number;
};
const CurrentSeasonMessage = ({
  rankingsCount,
  maximumSize,
}: CurrentSeasonMessageProps) => {
  return (
    <Vertical gap={2} center>
      <CurrentSeasonDiv borderColor="var(--c-rivals-friendlies)">
        <FontAwesomeIcon
          icon={faSearch}
          color="var(--c-rivals-friendlies)"
          size="xl"
        />
      </CurrentSeasonDiv>
      <Vertical gap={0.5} className="text-center">
        <HeadlineM>
          <FormattedMessage
            id="IncompleteLeaderboard.waitingForMore"
            defaultMessage="Waiting for more managers"
          />
        </HeadlineM>
        <LabelL color="var(--c-neutral-700)">
          <FormattedMessage
            id="IncompleteLeaderboard.nbOfPlayersFound"
            defaultMessage="{rankingsCount}/{maximumSize} found"
            values={{ rankingsCount, maximumSize }}
          />
        </LabelL>
      </Vertical>
    </Vertical>
  );
};

type Props = {
  isCurrentSeason: boolean;
  rankingsCount: number;
  maximumSize: number;
};
export const IncompleteLeaderboard = ({
  isCurrentSeason,
  rankingsCount,
  maximumSize,
}: Props) => {
  return (
    <GridBackground height={296} color="#454545">
      <StyledBackgroundAligned horizontalDelta={0} verticalDelta={-0.5}>
        {isCurrentSeason ? (
          <CurrentSeasonMessage
            rankingsCount={rankingsCount}
            maximumSize={maximumSize}
          />
        ) : (
          <PastSeasonMessage />
        )}
      </StyledBackgroundAligned>
    </GridBackground>
  );
};
